<template>
  <div class=" account-page assest-main page-padding-top" >

    <top-bar :title="$t(`account.title${pageType}`)"   @back="back"></top-bar>
    
    <div class="statistics-box">
      <div class="flex-center-start label">
        <span>{{i18n.t(`account.label1_${pageType}`)}}({{bitName}})</span>
        <img :src="showMoney ? eyeUrl2 : eyeUrl" alt="" @click="changeMoneyType">
      </div>

      <div class="flex-center-start money-info" >
        <div class="total flex-end-start">{{moneyStr}}</div>
        <div class="desc flex-end-start">≈ {{showMoney ?  parseFloat(bitMoney).toFixed(4) : '****'}} {{currencyVal}}</div>
      </div>


      <div class="flex today-static">
        <div class="flex-1 flex-column-start-center">
          <div class="name">{{i18n.t(`account.label2_${pageType}`)}}({{bitName}})</div>
          <div class="count" v-if="pageType != 3">{{freeMoney}}</div>
          <div class="count" v-else>{{spotData.EntrustAmount || '0.00'}}</div>
        </div>
        <div class="flex-1 flex-column-end-center">
          <div class="name">{{i18n.t(`account.label3`)}}({{bitName}})</div>
          <div class="count" v-if="pageType != 3">{{moneyUse}}</div>
          <div class="count" v-else>{{spotData.AvailableFunds || '0.00'}}</div>
        </div>
      </div>
    </div>

    <div class="tab-list flex-center">
      <div class="tab flex-column-center" @click="toPath('recharge')">
        <img :src="rechargeUrl" alt="">
        <span>{{i18n.t('assest.label2')}}</span>
      </div>
      <div class="tab flex-column-center" @click="toWithdraw">
        <img :src="withdrawUrl" alt="">
        <span>{{i18n.t('assest.label3')}}</span>
      </div>
      <div class="tab flex-column-center" @click="toTransfer">
        <img :src="transferUrl" alt="">
        <span>{{i18n.t('assest.label4')}}</span>
      </div>
      <div class="tab flex-column-center" @click="toLog">
        <img :src="debtUrl" alt="">
        <span>{{i18n.t(`assest.label5_${pageType}`)}}</span>
      </div>
    </div>

    <!--期权-->
    <div class="statistics-box small" v-if="pageType == 1">
      <div class="box-title">{{$t('account.label4')}}</div>
      <div class="flex today-static pad">
        <div class="flex-1 flex-column-start-center">
          <div class="name">{{$t('account.label5')}}({{bitName}})</div>
          <div class="count">{{optionReportData.TodayOptionOrder.Amount || '0.00'}}</div>
        </div>
        <div class="flex-1 flex-column-end-center">
          <div class="name">{{$t('account.label6')}}({{bitName}})</div>
          <div class="count" :class="optionReportData.TodayOptionOrder.Profit ? ( optionReportData.TodayOptionOrder.Profit > 0 ? 'green' : 'red') : ''">{{optionReportData.TodayOptionOrder.Profit || '0.00'}}</div>
        </div>
      </div>
    </div>

    <div class="statistics-box small" v-if="pageType == 1">
      <div class="box-title">{{$t('account.label7')}}</div>
      <div class="flex today-static">
        <div class="flex-1 flex-column-start-center">
          <div class="name">{{$t('account.label5')}}({{bitName}})</div>
          <div class="count">{{optionReportData.MonthOptionOrder.Amount || '0.00'}}</div>
        </div>
        <div class="flex-1 flex-column-end-center">
          <div class="name">{{$t('account.label6')}}({{bitName}})</div>
          <div class="count" :class="optionReportData.MonthOptionOrder.Profit ? ( optionReportData.MonthOptionOrder.Profit > 0 ? 'green' : 'red') : ''">{{optionReportData.MonthOptionOrder.Profit || '0.00'}}</div>
        </div>
      </div>
    </div>

    <div class="statistics-box small" v-if="pageType == 1">
      <div class="box-title">{{$t('account.label8')}}</div>
      <div class="flex today-static">
        <div class="flex-1 flex-column-start-center">
          <div class="name">{{$t('account.label5')}}({{bitName}})</div>
          <div class="count">{{optionReportData.LastMonthOptionOrder.Amount || '0.00'}}</div>
        </div>
        <div class="flex-1 flex-column-end-center">
          <div class="name">{{$t('account.label6')}}({{bitName}})</div>
          <div class="count" :class="optionReportData.LastMonthOptionOrder.Profit ? ( optionReportData.LastMonthOptionOrder.Profit > 0 ? 'green' : 'red') : ''">{{optionReportData.LastMonthOptionOrder.Profit || '0.00'}}</div>
        </div>
      </div>
    </div>

    <!--现货-->
    <!--合约-->
    <div class="flex-center-between search-line" v-show="pageType == 2 ||  pageType == 3">
      <div class="flex-center" >
        <span>{{i18n.t('account.label15')}}</span>
      </div>
      <div>
        <Search v-model="form.keyword" :placeholder="i18n.t('account.label16')" @clear="clearSearch" @search="searchBit" @input="searchBit"></Search>
      </div>
    </div>

    <div class="bit-list rankList clear " v-if="pageType == 2 ">
      <template v-for="(item, i) in bitList">
        <div class="list clear order "  :key="i">
          <div class="icon flex-center-start">
            <img :src="`/upload/${item.Currency.Logo}`" alt="">
            <span>{{item.Currency.ShortName}}</span>
          </div>
          <div class="flex-center-between assest-box">
            <div>
              <div class="label">{{$t('trade.label65')}}</div>
              <div class="count">{{(parseFloat(item.ContractUse) + parseFloat(item.ContractFree)).toFixed(4)}}</div>
              <div class="gray">${{resetBitMoney(parseFloat(item.ContractUse) + parseFloat(item.ContractFree), item.Currency.ShortName)}}</div>
            </div>
            <div>
              <div class="label">{{$t('trade.label66')}}</div>
              <div class="count">{{parseFloat(item.ContractFree).toFixed(4)}}</div>
              <div class="gray">${{resetBitMoney(parseFloat(item.ContractFree), item.Currency.ShortName)}}</div>
            </div>
            <div class="text-right">
              <div class="label">{{$t('trade.label67')}}</div>
              <div class="count">{{parseFloat(item.ContractUse).toFixed(4)}}</div>
              <div class="gray">${{resetBitMoney(parseFloat(item.ContractUse), item.Currency.ShortName)}}</div>
            </div>
          </div>
        </div>
      </template>
    </div>

    <div class="bit-list rankList clear " v-if="pageType == 3 ">
      <template v-for="(item, i) in bitList">
        <div class="list clear order "  :key="i">
          <div class="icon flex-center-start">
            <img :src="`/upload/${item.Currency.Logo}`" alt="">
            <span>{{item.Currency.ShortName}}</span>
          </div>
          <div class="flex-center-between assest-box">
            <div>
              <div class="label">{{$t('trade.label65')}}</div>
              <div class="count">{{(parseFloat(item.SpotUse) + parseFloat(item.SpotFree)).toFixed(4)}}</div>
              <div class="gray">${{resetBitMoney(parseFloat(item.SpotUse) + parseFloat(item.SpotFree), item.Currency.ShortName)}}</div>
            </div>
            <div>
              <div class="label">{{$t('trade.label66')}}</div>
              <div class="count">{{parseFloat(item.SpotFree).toFixed(4)}}</div>
              <div class="gray">${{resetBitMoney(parseFloat(item.SpotFree), item.Currency.ShortName)}}</div>
            </div>
            <div class="text-right">
              <div class="label">{{$t('trade.label67')}}</div>
              <div class="count">{{parseFloat(item.SpotUse).toFixed(4)}}</div>
              <div class="gray">${{resetBitMoney(parseFloat(item.SpotUse), item.Currency.ShortName)}}</div>
            </div>
          </div>
        </div>
      </template>
    </div>

    <!--金融-->
    
    <div class="page-title" v-if="pageType == 4">{{$t('account.title5')}}</div>
    <div class="statistics-box small clear" v-if="pageType == 4">
      <div class="box-title">{{$t('account.label4')}}</div>
      <div class="flex today-static">
        <div class="flex-1 flex-column-start-center">
          <div class="name">{{$t('account.label10')}}({{bitName}})</div>
          <div class="count">{{financialStatisticsObj.TodayAmount || '0.00'}}</div>
        </div>
        <div class="flex-1 flex-column-end-center">
          <div class="name">{{$t('account.label6')}}({{bitName}})</div>
          <div class="count" :class=" 10 > 0 ? 'green' : 'red'">{{financialStatisticsObj.TodayIncome || '0.00'}}</div>
        </div>
      </div>
    </div>

    <div class="statistics-box small " v-if="pageType == 4">
      <div class="box-title">{{$t('account.label9')}}</div>
      <div class="flex today-static">
        <div class="flex-1 flex-column-start-center">
          <div class="name">{{$t('account.label10')}}({{bitName}})</div>
          <div class="count">{{financialStatisticsObj.YesterdayAmount || '0.00'}}</div>
        </div>
        <div class="flex-1 flex-column-end-center">
          <div class="name">{{$t('account.label9')}}({{bitName}})</div>
          <div class="count" :class=" 10 > 0 ? 'green' : 'red'">{{financialStatisticsObj.YesterdayIncome || '0.00'}}</div>
        </div>
      </div>
    </div>

    <div class="page-title" v-if="pageType == 4">{{$t('account.title6')}}</div>

    <div class="statistics-box normal clear-margin" v-if="pageType == 4">
      <div class="flex today-static border">
        <div class="flex-1 flex-column-center">
          <div class="name">{{$t('account.label11')}}({{bitName}})</div>
          <div class="count">{{financialStatisticsObj.MonthAmount || '0.00'}}</div>
        </div>
        <div class="flex-1 flex-column-center line">
          <div class="name">{{$t('account.label12')}}({{bitName}})</div>
          <div class="count" :class=" 10 > 0 ? 'green' : 'red'">{{financialStatisticsObj.MonthIncome || '0.00'}}</div>
        </div>
      </div>
      <div class="flex today-static">
        <div class="flex-1 flex-column-center">
          <div class="name">{{$t('account.label13')}}({{bitName}})</div>
          <div class="count">{{financialStatisticsObj.LastMonthAmount || '0.00'}}</div>
        </div>
        <div class="flex-1 flex-column-center line">
          <div class="name">{{$t('account.label14')}}({{bitName}})</div>
          <div class="count" :class=" 10 > 0 ? 'green' : 'red'">{{financialStatisticsObj.LastMonthIncome || '0.00'}}</div>
        </div>
      </div>
    </div>

    <!--跟单-->
    
    <div class="page-title" v-if="pageType == 6">{{$t('account.title5')}}</div>
    <div class="statistics-box small clear" v-if="pageType == 6">
      <div class="box-title">{{$t('account.label4')}}</div>
      <div class="flex today-static">
        <div class="flex-1 flex-column-start-center">
          <div class="name">{{$t('account.label17')}}({{bitName}})</div>
          <div class="count">1132.39</div>
        </div>
        <div class="flex-1 flex-column-end-center">
          <div class="name">{{$t('account.label18')}}({{bitName}})</div>
          <div class="count" :class=" 10 > 0 ? 'green' : 'red'">1132.39</div>
        </div>
      </div>
    </div>

    <div class="statistics-box small " v-if="pageType == 6">
      <div class="box-title">{{$t('account.label9')}}</div>
      <div class="flex today-static">
        <div class="flex-1 flex-column-start-center">
          <div class="name">{{$t('account.label17')}}({{bitName}})</div>
          <div class="count">1132.39</div>
        </div>
        <div class="flex-1 flex-column-end-center">
          <div class="name">{{$t('account.label18')}}({{bitName}})</div>
          <div class="count" :class=" 10 > 0 ? 'green' : 'red'">1132.39</div>
        </div>
      </div>
    </div>

    <div class="page-title" v-if="pageType == 6">{{$t('account.title6')}}</div>

    <div class="statistics-box normal clear-margin" v-if="pageType == 6">
      <div class="flex today-static border">
        <div class="flex-1 flex-column-center">
          <div class="name">{{$t('account.label19')}}({{bitName}})</div>
          <div class="count">1132.39</div>
        </div>
        <div class="flex-1 flex-column-center line">
          <div class="name">{{$t('account.label12')}}({{bitName}})</div>
          <div class="count" :class=" 10 > 0 ? 'green' : 'red'">1132.39</div>
        </div>
      </div>
      <div class="flex today-static">
        <div class="flex-1 flex-column-center">
          <div class="name">{{$t('account.label20')}}({{bitName}})</div>
          <div class="count">1132.39</div>
        </div>
        <div class="flex-1 flex-column-center line">
          <div class="name">{{$t('account.label14')}}({{bitName}})</div>
          <div class="count" :class=" 10 > 0 ? 'green' : 'red'">1132.39</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import topBar from '@/components/topBar'
import { Popup, Button, Search } from 'vant'
import { myAssets, wallet, allTrades, contractProfit, optionReport, contractOverview} from '@/api/assest'
import { monetaryList } from '@/api/index'
import { financialStatistics } from '@/api/finance'
import { spotOverview } from '@/api/trade'
export default {
  components: {
    Popup,
    Button,
    Search,
    topBar
  },
  data() {
    return {
      form: {
        keyword: ''
      },
      backUrl: require('../../assets/imgs/icon-back.png'),
			helpUrl: require('../../assets/imgs/icon-help2.png'),
			logUrl: require('../../assets/imgs/icon-log.png'),
      closeUrl: require('../../assets/imgs/icon-close.png'),
      eyeUrl: require('../../assets/imgs/icon-eye.png'),
      eyeUrl2: require('../../assets/imgs/icon-eye2.png'),
      downUrl: require('../../assets/imgs/icon-arrow-down.png'),
      rightUrl: require('../../assets/imgs/icon-arrow-right.png'),
      rechargeUrl: require('../../assets/imgs/icon-recharge.png'),
      withdrawUrl: require('../../assets/imgs/icon-withdraw.png'),
      transferUrl: require('../../assets/imgs/icon-transfer3.png'),
      debtUrl: require('../../assets/imgs/icon-debt.png'),
      checkUrl: require('../../assets/imgs/icon-uncheck.png'),
      checkUrl2: require('../../assets/imgs/icon-checked.png'),
      showMoney: true,
      userMoney: '0.00',
      bitMoney: '0.0000',
      freeMoney: '0.00',
      moneyUse: '0.00',
      bitName: 'USDT',
      bitId: '1',
      showBitPage: false,
      pageType: 1,
      showZero: true,
      bitList: [], 
      bitListBak: [],
      bitTabIndex: 1,
      // bitTabList: [this.i18n.t('account.tab5') ,this.i18n.t('account.tab6')],
      bitTabList: [this.i18n.t('account.tab5') ],
      bitTabList2: [this.i18n.t('account.tab8')],
      ownerFinanceList: [],
      allFinanceList: [],
      allRateList: [],
      isAllOk: false,
      isOwnOk: false,
      profitMoney: '0.00',
      profitBitMoney: '0.00000',
      allTradesData: [],
      todayProfit: '0.00',
      todayProfitBit: '0.00000',
      optionReportData: {
        TodayOptionOrder: {},
        MonthOptionOrder: {},
        LastMonthOptionOrder: {},
      },
      financialStatisticsObj: {
        YesterdayIncome: 0,
        YesterdayAmount: 0,
        TodayIncome: 0,
        TodayAmount: 0,
        MonthIncome: 0,
        MonthAmount: 0,
        LastMonthIncome: 0,
        LastMonthAmount: 0,
      },
      spotData: {
        EntrustAmount: 0,
        AvailableFunds: 0,
      }
    }
  },
  computed: {
    moneyStr() {
      return this.showMoney ? parseFloat(this.userMoney).toFixed(4) : '****'
    },
    currencyVal() {
      return this.$store.state.currencyVal
    },
    currencyRate() {
      return this.$store.state.currencyRate
    },
    allBitList() {
      return this.$store.state.bitList
    },
  },
  mounted() {
    let type = this.$route.query.type
    this.pageType = type
    let bitName = localStorage.getItem('bitName')
    if (bitName) {
      this.bitName = bitName
      this.bitId = localStorage.getItem('bitId')
    }
   
    this.init()
    this.initWallet()
    this.initRate()
    if (this.pageType == 1) { // 期权
      this.initOption()
    } else if (this.pageType == 4) { // 金融
      this.initFinance()
    } else if (this.pageType == 3) { // 现货
      this.getSpotStatistics()
    } else if (this.pageType == 2) { // 合约
      this.initContract()
    }
   
  },
  methods: {
    initRate() {
			monetaryList().then(res => {
				this.allRateList = res.data.Items || []
			})
		},
    init() {
      myAssets({
        Unit: 'USDT'
      }).then(res => {
        let data = res.data
        if (this.pageType == 1) { // 期权
          this.userMoney = parseFloat(data.Option).toFixed(4)
        } else if (this.pageType == 3) { // 现货
          this.userMoney = parseFloat(data.Spot).toFixed(4)
        } else if (this.pageType == 4) { // 金融
          this.userMoney = parseFloat(data.Finance).toFixed(4)
        } else if (this.pageType == 5) { // 资金
          this.userMoney = parseFloat(data.Total).toFixed(4)
        } else if (this.pageType == 6) { // 跟单
          this.userMoney = parseFloat(data.Finance).toFixed(4)
        }

        if (this.pageType != 2) {
          this.bitMoney = this.userMoney * this.currencyRate
        }
      
      })
    },
    getSpotStatistics() {
      spotOverview().then(res => {
        this.spotData = res.data || {}
      })
    },
    initWallet() {
      let form = new FormData()
      form.append('current', 1)
      form.append('pageSize', 10)
      form.append('ShortName', '')
      wallet(form).then(res => {
        let data = res.data.Items[0]
        if (data) {
          if (this.pageType == 1) { // 期权
            this.moneyUse = parseFloat(data.OptionUse).toFixed(4)
          } else if (this.pageType == 2) { // 合约
            this.moneyUse = parseFloat(data.ContractUse).toFixed(4)
          } else if (this.pageType == 3) { // 现货
            this.moneyUse = parseFloat(data.SpotUse).toFixed(4)
          } else if (this.pageType == 4) { // 金融
            this.moneyUse = parseFloat(data.FinanceUse).toFixed(4)
          } else if (this.pageType == 5) { // 资金
            this.moneyUse = parseFloat(data.CapitalUse).toFixed(4)
          } else if (this.pageType == 6) { // 跟单
            this.moneyUse = parseFloat(data.FinanceUse).toFixed(4)
          }
        }

        // 资产
        if (this.pageType == 2 || this.pageType == 3) {
          let list = res.data.Items.filter(v => {
            return v.Currency.ShortName != 'USDT'
          })
          this.bitList = list
          this.bitListBak = JSON.parse(JSON.stringify(list))
        }
      })
    },
    initContract() {
      contractOverview().then(res => {
        let data = res.data
        this.userMoney = parseFloat(data.ContractValuation).toFixed(4)
        this.bitMoney = this.userMoney * this.currencyRate

        this.freeMoney =  parseFloat(data.PositionAmount).toFixed(4)
      })
    },
    initOption() {
      optionReport().then(res => {
        this.optionReportData= res.data
        this.freeMoney = res.data.WaitSettlement ? res.data.WaitSettlement.toFixed(2) : '0.00'
      })
    },
    initFinance() {
      financialStatistics().then(res => {
        this.financialStatisticsObj = res.data
      })
    },
    getUserKey() {
      let key = ''
      switch (this.pageType + '') {
        case '1': key = 'SpotUse'; break;
        case '2': key = 'ContractUse'; break;
        case '3': key = 'OptionUse'; break;
        case '4': key = 'FinanceUse'; break;
        case '5': key = 'CapitalUse'; break;
        default: break;
      }
      return key
    },
    getFeeKey() {
      let key = ''
      switch (this.pageType + '') {
        case '1': key = 'SpotFree'; break;
        case '2': key = 'ContractFree'; break;
        case '3': key = 'OptionFree'; break;
        case '4': key = 'FinanceFree'; break;
        case '5': key = 'CapitalFree'; break;
        default: break;
      }
      return key
    },
    back() {
			this.$router.go(-1)
		},
    toLog() {
			this.$router.push({
				name: 'assestLog',
			})
		},
    changeMoneyType() {
      this.showMoney = !this.showMoney
    },
    changeBit() {
      this.showBitPage = true
    },
    cancel() {
      this.showBitPage = false
      this.showRecharge = false
    },
    resetSpotMoney(count, id) {
      let index = this.allTradesData.findIndex(v => {
        return v.CurrencyId == id
      })
      if (index > -1) {
        let price = this.allTradesData[index].Price
        return parseFloat(price * count).toFixed(4)
      } else {
        return parseFloat(count).toFixed(4)
      }
    },
    toPath(path) {
      if (path) {
        this.$router.push({
          name: path
        })
      }
    },
    clearSearch() {
      this.form.keyword = ''
      this.bitList = [].concat(this.bitListBak)
    },
    searchBit() {
      this.bitList = this.bitListBak.filter(v => {
        return v.Currency.ShortName.toLowerCase().indexOf(this.form.keyword) > -1
      })
    },
    changeShowType() {
      this.showZero = !this.showZero
      let filterList = ['USDT']
      if (this.form.keyword) {
        this.bitList = this.bitListBak.filter(v => {
          let userKey = this.getUserKey()
          let feeKey = this.getFeeKey()
          return (parseFloat(v[userKey]) != 0 || parseFloat(v[feeKey]) != 0 || this.showZero) && v.Currency.Name.toLowerCase().indexOf(this.form.keyword) > -1
        })
      } else {
        this.bitList = this.bitListBak.filter(v => {
          let userKey = this.getUserKey()
          let feeKey = this.getFeeKey()
          return (parseFloat(v[userKey]) != 0 || parseFloat(v[feeKey]) != 0) || this.showZero
        })
      }
    },
    changeBitTab(i) {
      this.bitTabIndex = i
    },
     toPath(path) {
      if (path) {
        this.$router.push({
          name: path
        })
      }
    },
    toWithdraw() {
      if (this.realNameStatus == '2') {
        this.toPath('withdraw')
      } else if (this.realNameStatus == '1') {
        this.$store.state.warningMsg = this.i18n.t('setting.desc8')
      } else {
        this.toPath('withdraw')
      }
    },
    toLog() {
     
      this.$router.push({
        name: 'assestLog',
        query: {
          type: this.pageType
        }
      })
    },
    resetBitMoney(money, ShortName) {
			let rate = 1
      // 获取bit价格
      let index = this.allBitList.findIndex(v => {
        return v.ShortName == ShortName
      })
      if (index > -1) {
        rate = this.allBitList[index].count || 1
      }
			return (money * rate).toFixed(4)
		},
    toTransfer() {
			let type = 1
			if (this.pageType == 1) {//期权
				type = 2
			} else if (this.pageType == 2) {//合约
				type = 3
			} else if (this.pageType == 3) { // 现货
				type = 4
			} else if (this.pageType == 4) { // 金融
				type = 5
			} else if (this.pageType == 6) { // 跟单
				type = 6
			}
			this.$router.push({
				name: 'transfer',
				query: {
					type: type
				}
			})
		}
  }
}
</script>